import {
  ActiveSaleIdUpdatedDocument,
  ActiveSaleIdUpdatedSubscription,
  ActiveSaleIdUpdatedSubscriptionVariables,
  GetActiveSaleIdQuery,
  useActiveSaleHighlightsUpdatedSubscription,
  useGetActiveSaleHighlightsQuery,
  useGetActiveSaleIdQuery,
} from "client/graphql/commerce-v2-api"
import { isEqual } from "lodash"
import { useEffect } from "react"

export function useActiveSaleHighlights(channelId: string) {
  const result = useGetActiveSaleHighlightsQuery()

  useActiveSaleHighlightsUpdatedSubscription({
    variables: { channelId },
    onData: ({ data: { data } }) => {
      const updatedSale = data?.commerceV2_activeSaleUpdated.activeSale
      const previousSale =
        result.previousData?.commerceV2_instance.activeSale

      // Refetch the activeSaleHighlights query only if we detect a change to
      // productIds. This allows us to trim the size of the subscription payload
      // by removing the need to resolve product data in every event.
      if (
        updatedSale &&
        updatedSale?.id === previousSale?.id &&
        !isEqual(updatedSale.productIds, previousSale.productIds)
      ) {
        result.refetch()
      }
    },
  })

  return [result.data?.commerceV2_instance?.activeSale, result] as const
}

export function useIsSaleActive(channelId: string) {
  const result = useGetActiveSaleIdQuery()

  useEffect(() => {
    result.subscribeToMore<
      ActiveSaleIdUpdatedSubscription,
      ActiveSaleIdUpdatedSubscriptionVariables
    >({
      document: ActiveSaleIdUpdatedDocument,
      variables: {
        channelId,
      },
      updateQuery(prev, updated): GetActiveSaleIdQuery {
        return {
          commerceV2_instance:
            updated.subscriptionData.data.commerceV2_activeSaleUpdated,
        }
      },
    })
  }, [])

  return [
    !!result.data?.commerceV2_instance?.activeSale?.id,
    result,
  ] as const
}
